
import "./index.css"

const NoPageFound = () => {
    return (
        <>
             <div className="page_notfound_container container-xxl container-p-y">
                    <div className="misc-wrapper">
                        <h1 className="mb-2 mx-2 text-center" style={{ lineHeight: '6rem', fontSize: '6rem' }}>404</h1>
                        <h4 className="mb-2 mx-2 text-center">Page Not Found️ ⚠️</h4>
                        <p className="mb-6 mx-2 text-center" >we couldn't find the page you are looking for</p>
                        <div className="mt-4 text-center">
                            <img src="../../assets/img/illustrations/page-misc-error.png" alt="page-misc-error-light" width={225} className="img-fluid text-center" />
                        </div>
                    </div>
                </div>
            

        </>

    )
}

export default NoPageFound
